import { API_BASE_URL, FAILURE, POST, GET, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createConfiguracionExcelImportarModelo(obj) {
    try {
        let data = { error: true };
        const { code } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-modelo/create-configuracion-importar-excel-modelo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data.error = false;
        }
        return data;
    } catch (err) {
        console.log("createConfiguracionExcelImportarModelo err");
        console.log(err);
        return { error: true };
    }
}

export async function obtenerConfiguracionExcelImportarModelo() {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-modelo/obtener-configuracion-importar-excel-modelo",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data.body = body[0];
            } else {
                data.body = null;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerConfiguracionExcelImportarModelo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarConfiguracionExcelImportarModelo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-modelo/actualizar-configuracion-importar-excel-modelo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarConfiguracionExcelImportarModelo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function guardarImportarExcelModelo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-modelo/guardar-importar-excel-modelo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("guardarImportarExcelModelo err");
        console.log(err);
        return { error: true, message: err };
    }
}
